import { Component, OnInit,Input,Output,EventEmitter,SimpleChanges,OnChanges } from '@angular/core';
import { AnalyticsService } from 'src/app/_services';

@Component({
  selector: 'app-portfolioageinganalysis',
  templateUrl: './portfolioageinganalysis.component.html',
  styleUrls: ['./portfolioageinganalysis.component.css']
})
export class PortfolioageinganalysisComponent implements OnInit {

  @Input('showperformance') showperformance = 'no';
  @Input('currentUser') currentUser:any;
  @Output() openportfoliotargetsettings = new EventEmitter();
  loading = true;
  platform_summary: any;
  constructor(private analytics: AnalyticsService) { }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {  
      
      let change = changes[propName];
      
      let curVal  = JSON.stringify(change.currentValue);
      let prevVal = JSON.stringify(change.previousValue); 
      // console.log(propName);
      // console.log(change.currentValue);
      // console.log(prevVal);
      if (change.currentValue === 'yes') {
         this.getPortfolioTarget();
      } else {
        console.log('Not yes')
      }
    }
  }
  getPortfolioTarget(){
    this.loading = true;
    this.analytics.getPortfolioTarget(this.currentUser.token)
      .subscribe(data => { 
        this.loading = false;
        this.platform_summary = data;
      });
  }
  openPortfolioTarget(){
    this.openportfoliotargetsettings.emit({});
  }

}
